import { selector } from 'recoil';
import { authAtom } from './atom';

const userSelector = selector({
  key: 'userSelector',
  get: ({ get }) => get(authAtom).user,
});

const isLoadingSelector = selector({
  key: 'isLoadingSelector',
  get: ({ get }) => get(authAtom).isLoading,
});
export { userSelector, isLoadingSelector };
